import { useDispatch } from 'react-redux'
import { CardHeader } from 'reactstrap'
import { onVideoProgress } from 'store/Course/actions'
import { onVideoEnd } from 'store/Course/actions'
import { fetchTrackingByCourseContent } from 'store/Course/actions'

const { default: Play } = require('./Play')

const ViewVideo = (props) => {
  const dispatch = useDispatch()
  return (
    <div className='tl-employee-content-wrapper h-100'>
      {/* <CardHeader className={`text-center h3`}>{props.name}</CardHeader> */}
      {(() => {
        const { id } = props.match.params

        if (!id) {
          return null
        }

        const content = props.content.filter((item) => item.id == parseInt(id))

        if (!content.length) {
          return null
        }

        const data = props.tracking.filter((item) => item.content_id == id)[0]

        console.log('leart27', props)

        return (
          <Play
            {...content[0].content[0]}
            id={content[0].id}
            tracking={data || {}}
            rewatchedVideo={props.rewatchedVideo}
            onVideoEnd={(data) => dispatch(onVideoEnd(data))}
            onVideoProgress={(data) => dispatch(onVideoProgress(data))}
            fetchTrackingByCourseContent={() =>
              dispatch(fetchTrackingByCourseContent())
            }
            courseId={props.course_id}
            currentCourse={props.currentCourse}
            courseContents={props.content}
          />
        )
      })()}
    </div>
  )
}

export default ViewVideo
